/* eslint-disable @next/next/no-img-element */
import React, { useState, useEffect } from "react";
import CustomModalLayout from "../Auth/CustomModalLayout";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
  type CarouselApi,
} from "../../../shadcn/components/ui/carousel";
import { Card, CardContent } from "../../../shadcn/components/ui/card";
import Dot from "../../../icons/Dot";
import { getWatermarkedImgixUrl } from "services";

interface PDGallerySectionProps {
  images: { uuid: string; path_to_file: string }[];
}

export default function PDGallerySection({ images }: PDGallerySectionProps) {
  const galleryImages = images.slice(0, 5);

  const [open, setOpen] = useState(false);
  const [imageToShow, setImageToShow] = useState<{
    images: { uuid: string }[];
    index: number;
  } | null>(null);
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const [api, setApi] = useState<CarouselApi>();
  const [totalSlides, setTotalSlides] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(0);

  const imageClickHandler = (index: number) => {
    setImageToShow({ images, index });
    setCurrentIndex(index);
    setOpen(true);
  };

  useEffect(() => {
    if (api) {
      setTotalSlides(api.scrollSnapList().length);
      setCurrentSlide(api.selectedScrollSnap() + 1);

      const updateCurrentSlide = () =>
        setCurrentSlide(api.selectedScrollSnap() + 1);
      api.on("select", updateCurrentSlide);

      return () => {
        api.off("select", updateCurrentSlide); // Cleanup listener
      };
    }
  }, [api]);

  useEffect(() => {
    if (open && api && imageToShow) {
      api.scrollTo(imageToShow.index); // Navigate to the desired slide
    }
  }, [open, api, imageToShow]);

  return (
    <>
      {galleryImages.length > 0 && (
        <div className="mt-14 lg:mt-10 py-[42px] bg-brand-bgLightGrey px-customPaddingMobile">
          <h3>Gallery</h3>
          <div className="grid grid-cols-2 lg:grid-cols-4 mt-11 gap-4">
            {galleryImages.map((image, index) => {
              const url = image?.path_to_file;
              const path = new URL(url).pathname.slice(1);
              return (
                <div
                  key={image.uuid}
                  onClick={() => imageClickHandler(index)}
                  className={`${
                    index === 0
                      ? "col-span-2 lg:row-span-2 h-[340px]"
                      : "h-[143px] lg:h-[160px]"
                  } text-center border-[1px] bg-white hover:shadow-lg hover:scale-[1.01] hover:shadow-300 hover:duration-300 hover:ease-out relative cursor-pointer`}
                >
                  <img
                    className="object-cover w-full h-full"
                    src={getWatermarkedImgixUrl(
                      `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${path}`,
                    )}
                    alt={`Property Gallery Image ${index + 1}`}
                  />
                  {index === 4 && (
                    <div className="absolute top-0 left-0 h-[143px] lg:h-[150px] w-full bg-[#1a19199c] text-center flex justify-center items-center text-white text-[38px]">
                      <p>{images.length - galleryImages.length}+</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          {imageToShow && (
            <CustomModalLayout
              open={open}
              onClose={() => setOpen(false)}
              className="min-w-[100px] md:max-w-[762px] w-full lg:max-w-[862px] lg:px-14 px-0  lg:mx-12 lg:pb-[32px]"
            >
              <h3 className="hidden lg:block text-md sm:text-xl font-openSans text-brand-bgBlack pt-0 lg:pt-4 mb-2 mobile:mb-6 lg:mb-10">
                Gallery
              </h3>
              <Carousel setApi={setApi} className="block">
                <CarouselContent className="">
                  {imageToShow.images.map((data: any, index) => (
                    <CarouselItem
                      key={index}
                      className="p-0 pl-4 lg:pl-8 pr-0 lg:pr-5 border-none"
                    >
                      <Card className="w-full overflow-hidden rounded-lg">
                        <CardContent className="flex aspect-square items-center justify-center rounded-lg p-0">
                          <img
                            src={getWatermarkedImgixUrl(
                              `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${
                                new URL(data?.path_to_file).pathname.slice(1) ||
                                data?.uuid
                              }`,
                            )}
                            alt={`Gallery Image ${index + 1}`}
                            className="object-fill w-full h-auto max-h-[200px]  sm:max-h-[300px]"
                          />
                        </CardContent>
                      </Card>
                    </CarouselItem>
                  ))}
                </CarouselContent>
                <CarouselPrevious className="rounded-none left-6 lg:-left-12  md:h-10 md:w-10 border-brand-textLightGrey" />
                <CarouselNext className="rounded-none right-6 lg:-right-12 md:h-10 md:w-10 border-brand-textLightGrey" />
              </Carousel>
            </CustomModalLayout>
          )}
        </div>
      )}
    </>
  );
}
